import { createRouter, createWebHistory } from "vue-router";
// Vistas
import TipoDocumentosIndex from '../components/cruds/TipoDocumentosIndex'
import ProductosIndex from '../components/cruds/ProductosIndex'
import OrigenDestinosIndex from '../components/cruds/OrigenDestinosIndex'
import ChoferesIndex from '../components/cruds/ChoferesIndex'
import EmpresasIndex from '../components/cruds/EmpresasIndex'
import UsersIndex from '../components/seguridad/UsersIndex'
import TMovimientosIndex from '../components/cruds/TMovimientosIndex'
import TCamionesIndex from '../components/cruds/TCamionesIndex'
import MPreciosIndex from '../components/cruds/MPreciosIndex'
import CargaManual from '../components/movimientos/CargaManual'
import MovimientosIndex from '../components/movimientos/MovimientosIndex'
import Dashboard from '../components/home/Dashboard'

const routes = [
	{
		path: '/home/',
		name: 'home.admin',
		component: Dashboard
	},
	{
		path: '/users',
		name: 'users.index',
		component: UsersIndex,
		beforeEnter: (to, from, next) => {
			if ([0, 1].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	},
	{
		path: '/empresas',
		name: 'empresas.index',
		component: EmpresasIndex,
		beforeEnter: (to, from, next) => {
			if ([0, 1, 2, 3].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	},
	{
		path: '/choferes',
		name: 'choferes.index',
		component: ChoferesIndex,
		beforeEnter: (to, from, next) => {
			if ([0, 1, 2, 3].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	},
	{
		path: '/odestinos',
		name: 'odestinos.index',
		component: OrigenDestinosIndex,
		beforeEnter: (to, from, next) => {
			if ([0, 1, 2, 3].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	},
	{
		path: '/productos',
		name: 'productos.index',
		component: ProductosIndex,
		beforeEnter: (to, from, next) => {
			if ([0, 1].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	},
	{
		path: '/tdocumentos',
		name: 'tdocumentos.index',
		component: TipoDocumentosIndex,
		beforeEnter: (to, from, next) => {
			if ([0, 1].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	},
	{
		path: '/tmovimientos',
		name: 'tmovimientos.index',
		component: TMovimientosIndex,
		beforeEnter: (to, from, next) => {
			if ([0, 1, 2].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	}
	,{
		path: '/tcamiones',
		name: 'tcamiones.index',
		component: TCamionesIndex,
		beforeEnter: (to, from, next) => {
			if ([0, 1, 2].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	},
	,{
		path: '/mprecios',
		name: 'mprecios.index',
		component: MPreciosIndex,
		beforeEnter: (to, from, next) => {
			if ([0, 1, 2].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	},
	{
		path: '/movimiento/:id?',
		name: 'movimientos.carga',
		component: CargaManual,
		beforeEnter: (to, from, next) => {
			if ([0, 1, 2].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	},	
	{
		path: '/movimientos',
		name: 'movimientos.index',
		component: MovimientosIndex,
		beforeEnter: (to, from, next) => {
			if ([0, 1, 2].includes(window.Laravel.user.seg_rol_id))
				next()
			else
				next(false)
		}
	},
]

export default createRouter({
	mode: 'history',
	history: createWebHistory(),
	routes
})
